import QRCode from 'qrcode';
import { DOORSTEPS_BASE_URL } from '../constants';

export function getLandingPageUrl(slug: string, uprn?: string): string {
  const base = `${DOORSTEPS_BASE_URL}/l/${slug}`;
  return uprn ? `${base}?u=${encodeURIComponent(uprn)}` : base;
}

export async function generateQrPng(slug: string, uprn?: string): Promise<string> {
  return QRCode.toDataURL(getLandingPageUrl(slug, uprn), {
    width: 512,
    margin: 2,
    color: { dark: '#000000', light: '#ffffff' },
    errorCorrectionLevel: 'M',
  });
}

export async function generateQrSvg(slug: string, uprn?: string): Promise<string> {
  return QRCode.toString(getLandingPageUrl(slug, uprn), {
    type: 'svg',
    width: 512,
    margin: 2,
    color: { dark: '#000000', light: '#ffffff' },
    errorCorrectionLevel: 'M',
  });
}
